module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r con-wrap"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("账号登录")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": "输入用户名/手机号/注册邮箱进行登录",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pas),
      expression: "pas"
    }],
    staticClass: "pas",
    attrs: {
      "type": "password",
      "placeholder": "输入密码",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.pas)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.checkMsg($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pas = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrong"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeshow),
      expression: "codeshow"
    }],
    staticClass: "jtocode"
  }), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.checkMsg
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "hrefs clearfix"
  }, [_c('router-link', {
    staticClass: "res",
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.changeState
    }
  }, [_vm._v("立即注册")])]), _vm._v(" "), _c('router-link', {
    staticClass: "forget",
    attrs: {
      "to": {
        name: 'findPas'
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.forget
    }
  }, [_vm._v("忘记密码")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "login-way"
  }, [_vm._v("使用第三方账号登陆")]), _vm._v(" "), _c('div', {
    staticClass: "elLogin"
  }, [_c('a', {
    staticClass: "el1",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getQQ
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "el2",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getWEI
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "el3",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.getBO
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l"
  }, [_c('div', [_c('span', [_vm._v("快速创建您的个性化机器人只需四步")]), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../../img/icon3.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56d694c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 107
// module chunks = 1